<template>
    <div class="container">
        <h2 class="text-center title">   {{ $t('home.testimonial.title') }}</h2>
        <a href="#" class="view-all">  {{ $t('home.testimonial.show_all') }}</a>
        <p class="text-center description">
            {{ $t('home.testimonial.description') }}
        </p>

        <div class="row">
            <div class="col-lg-4 col-12" v-for="index in [1,2,3]" :key="index">
                <div class="testimonial-card text-center p-4">
                    <div class="image-container">
                        <img src="@/assets/images/home/testimonial/user.png" alt="User Image" class="user-image">
                    </div>
                    <h5 class="fw-bold mt-2 name">محمد الأنصاري</h5>
                    <div class="stars mt-1">
                        <img src="@/assets/images/home/testimonial/star.png" >
                        <img src="@/assets/images/home/testimonial/star.png" >
                        <img src="@/assets/images/home/testimonial/star.png" >
                        <img src="@/assets/images/home/testimonial/star.png" >
                        <img src="@/assets/images/home/testimonial/star.png">
                    </div>
                    <p class="mt-3 content">
                        بفضل الله ثم هذه المنصة، أصبحت لدي رؤية أشمل عن القرآن الكريم من خلال دروس التلاوة وعلوم القرآن
                        المتكاملة.
                    </p>
                </div>
            </div>
        </div>
        <DotsPagination/>
    </div>
</template>
<script>
import DotsPagination from '../Pagination/DotsPagination.vue';

export default {
    components : {
        DotsPagination
    }
}
</script>
<style scoped>
.container {
    margin-top: 40px;
}

/* General Text Styles */
.title {
    font-size: 36px;
    font-weight: 500;
}

.description {
    font-size: 18px;
    font-weight: 400;
    margin-top: 25px;
}

.view-all {
    font-size: 20px;
    font-weight: 500;
    color: #BF9F35;
    /* Gold color */
    text-decoration: none;
    float: inline-end;
    text-decoration: underline;
    cursor: pointer;
}

.testimonial-card {
    background-color: #f8f5eb;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 400px;
    margin: auto;
    margin-bottom: 10px;
}

.image-container {
    width: 116px;
    height: 116px;
    border-radius: 50%;
    overflow: hidden;
    margin-top: -50px;
    border: 4px solid white;
}

.user-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.row {
    margin-top: 50px;
}

.name {
    font-size: 18px;
    font-weight: 500;
}

.content {
    font-size: 18px;
    font-weight: 400;
}


</style>